import script from "./Tip.vue?vue&type=script&setup=true&lang=js"
export * from "./Tip.vue?vue&type=script&setup=true&lang=js"

import "./Tip.vue?vue&type=style&index=0&id=313d55de&lang=css"

const __exports__ = script;

export default __exports__